import React from 'react';
import { withoutProfilePicture } from '../../utils/handler';
import CopyButton from '../Employees/CopyButton';

function ClientProfileCard({ profileData, stats = [] }) {
  return (
    <div className="card teacher-card  mb-3">
      <div className="card-body d-flex teacher-fulldeatil">
        <div className="profile-teacher pe-xl-4 pe-md-2 pe-sm-4 pe-4 text-center w220">
          <img
            src={
              profileData?.profilePicture
                ? profileData?.profilePicture
                : withoutProfilePicture(profileData)
            }
            alt=""
            className="avatar xl rounded-circle img-thumbnail shadow-sm"
            style={{ cursor: 'default' }}
          />
        </div>
        <div className="teacher-info ps-xl-3 ps-md-3 ps-sm-3 ps-3 w-100 ep-hero-row">
          <div className="ep-hero-main">
            <div className="d-flex align-items-center flex-wrap gap-2 ep-hero-name">
              <h6 className="mb-0 fw-bold d-block fs-6">{profileData?.name || '-'}</h6>
              {profileData?.zohoEmployeeId != null && profileData?.zohoEmployeeId !== '' ? (
                <span className="ep-emp-id">ID #{profileData.zohoEmployeeId}</span>
              ) : null}
            </div>
            {profileData?.designation?.name ? (
              <div className="ep-hero-designation">{profileData.designation.name}</div>
            ) : null}
            <div className="ep-hero-contacts">
              {profileData?.phone ? (
                <a
                  className="ep-hero-contact"
                  href={`tel:${profileData?.countryCode || ''}${profileData.phone}`}
                >
                  <i className="icofont-ui-touch-phone" aria-hidden />
                  <span>
                    {profileData?.countryCode ? `${profileData.countryCode} ` : ''}
                    {profileData.phone}
                  </span>
                </a>
              ) : null}
              {profileData?.email ? (
                <span className="ep-hero-contact ep-hero-contact--copy">
                  <a className="ep-hero-contact__link" href={`mailto:${profileData.email}`}>
                    <i className="icofont-email" aria-hidden />
                    <span>{profileData.email}</span>
                  </a>
                  <CopyButton text={profileData.email} label="Copy email" />
                </span>
              ) : null}
            </div>
          </div>
          {stats.length ? (
            <div className="ep-hero-stats">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className={`ep-hero-stat${s.accent ? ` ep-hero-stat--${s.accent}` : ''}`}
                >
                  <span className="ep-hero-stat__icon" aria-hidden>
                    <i className={`bi ${s.icon}`} />
                  </span>
                  <div className="ep-hero-stat__body">
                    <span className="ep-hero-stat__label">{s.label}</span>
                    <span
                      className={`ep-hero-stat__value${s.tone ? ` ep-hero-stat__value--${s.tone}` : ''}`}
                    >
                      {s.value}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default ClientProfileCard;
